import type { RequestConfig } from "@/services/api";
import { api } from "@/services/api";

export interface TTSResponse {
  filename: string;
  cache: boolean;
  usage: number;
  unit: string;
}

export interface TTSResquest {
  input: string;
  model: string;
  voice: string;
  response_format?: "mp3" | "opus" | "aac" | "flac" | "wav" | "pcm";
  speed?: number;
  instructions?: string;
  extra_body?: Record<string, any>;
}

export interface VoiceParams {
  name: string;
  languages: string[];
  key: string;
}

export const ttsApi = {
  async generate(body: TTSResquest, config?: RequestConfig): Promise<TTSResponse> {
    const { data } = await api.post<TTSResponse>("/tts/generate", body, config);

    return data;
  },

  async voices(): Promise<Record<string, VoiceParams[]>[]> {
    const { data } = await api.get<Record<string, any>[]>("/tts/voices");

    return data;
  },
};
